import {
  isPipeline,
  getGlobalEventProperties,
  getProfileProperties
} from '@/common/helpers/tracking-utils';
import { getUserSub } from './account/userSession';

const HEAP_PREFIX = `SamKnowsVolunteers_`;

export function initiateHeap(): void {
  if (isPipeline()) {
    return;
  }
  const appId = process.env.VUE_APP_HEAP_ID;

  window?.heap?.load(appId);
}

function prefixProperties(
  properties: Record<string, unknown>
): Record<string, unknown> {
  return Object.keys(properties).reduce((acc, key) => {
    const prefixObject = {
      [`${HEAP_PREFIX}${key}`]: properties[key]
    };

    return {
      ...acc,
      ...prefixObject
    };
  }, {});
}

export function setHeapIdentity(): void {
  const userId = getUserSub();
  if (isPipeline() || !userId) {
    return;
  }
  const profileProperties = getProfileProperties();
  const prefixedProfileProperties = prefixProperties(profileProperties);

  window?.heap?.addUserProperties(prefixedProfileProperties);
}

export function setHeapGlobalEventProperties(): void {
  if (isPipeline()) {
    return;
  }
  const eventProperties = getGlobalEventProperties();
  const prefixedEventProperties = prefixProperties(eventProperties);

  window?.heap?.addEventProperties(prefixedEventProperties);
}

/**
 * Track an event via Heap. Heap auto track most events so this should only be used for event that can't be tracked automatically
 * This can be logs, sending extra data from APIs, hover events
 *
 * Note: Currently, heap.track calls cannot be named click, change, submit as it clashes with internal variables.
 * @param  {string} eventName
 * @param  {Record<string, unknown>} properties?
 * @returns void
 */
export function heapTrack(
  eventName: string,
  properties?: Record<string, unknown>
): void {
  if (isPipeline()) {
    return;
  }

  window?.heap?.track(`${HEAP_PREFIX}${eventName}`, properties);
}
